import './EmptyState.css';

/**
 * Leer-, Lade- und Zugriffshinweise — EIN Muster für alle Seiten.
 *
 * Vorher gab es vier: die Karte hier (nur in Dashboard.css, also nur für
 * Anmeldungen/Personen gedacht), `.checkin-gate` (Icon + Satz), `.kiosk-gate`
 * und `.my-reg-empty`. Dieselbe Aussage — „hier ist nichts" oder „du darfst
 * hier nicht rein" — sah dreimal anders aus. Jetzt kommt sie von hier.
 *
 * Props:
 *   icon      Symbol im Kreis (Icon-Komponente oder Wegzeichen); optional
 *   title     die eine Zeile, die sagt, was los ist
 *   children  Erklärung darunter; optional
 *   action    ein Knopf o. ä. unter dem Text; optional
 *   compact   weniger Luft — für Bereiche innerhalb einer Seite (Liste leer,
 *             kein Treffer), nicht für die ganze Seite
 *   busy      Ladezustand: setzt aria-busy, damit Vorlesesoftware „lädt" sagt
 */
export function EmptyState({ icon, title, children, action, compact = false, busy = false, className = '' }) {
  return (
    <div
      className={`empty-state ${compact ? 'empty-state--compact' : ''} ${className}`}
      role={busy ? 'status' : undefined}
      aria-busy={busy || undefined}
    >
      {icon && <div className="empty-state-icon">{icon}</div>}
      {title && <div className="empty-state-title">{title}</div>}
      {children && <div className="empty-state-body">{children}</div>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}

export default EmptyState;
